// extracted by mini-css-extract-plugin
export default {"wrapper":"Infopanel_wrapper__-cmee","main":"Infopanel_main__QiuO5","aside":"Infopanel_aside__N4YSP","title":"Infopanel_title__5H8qb"};